import type { JSX } from 'react';
import { Box, TableRow, TableCell, TableHead, TableSortLabel } from '@mui/material';

// ----------------------------------------------------------------------

const visuallyHidden: React.CSSProperties = {
	border: 0,
	margin: -1,
	padding: 0,
	width: '1px',
	height: '1px',
	overflow: 'hidden',
	position: 'absolute',
	whiteSpace: 'nowrap',
	clip: 'rect(0 0 0 0)',
};

// Define interfaces for props
export interface HeadCell {
	id: string;
	align: 'left' | 'center' | 'right';
	label: string;
	disableSort?: boolean;
}

interface ListHeadProps {
	order: 'asc' | 'desc';
	orderBy: string;
	headLabel: HeadCell[];
	onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
}

export default function ListHead({ order, orderBy, headLabel, onRequestSort }: ListHeadProps): JSX.Element {
	const createSortHandler = (property: string) => (event: React.MouseEvent<unknown>) => {
		onRequestSort(event, property);
	};

	return (
		<TableHead>
			<TableRow>
				{headLabel.map((headCell) => (
					<TableCell key={headCell.id} align={headCell.align} sortDirection={orderBy === headCell.id ? order : false}>
						<TableSortLabel
							hideSortIcon={headCell.disableSort}
							active={orderBy === headCell.id}
							direction={orderBy === headCell.id ? order : 'asc'}
							onClick={headCell.disableSort ? undefined : createSortHandler(headCell.id)}
						>
							{headCell.label}
							{orderBy === headCell.id ? (
								<Box sx={{ ...visuallyHidden }}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</Box>
							) : null}
						</TableSortLabel>
					</TableCell>
				))}
			</TableRow>
		</TableHead>
	);
}
